<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: "app",
  mounted(){
    let version = "version 20260325";
    let environment = process.env.NODE_ENV;

    console.log(version + " - " + environment)
  }
}

</script>


<style lang="scss">
@import "style/scss/style.scss";
</style>
